<template>
	<section class="ImageMap">
		<div class="image-area" :style="{ '--image': `url(${myMeta[0].image})`, '--ratio': ratio }">
			<A
				class="button"
				v-for="btn in imageMapButtons"
				:key="`btn_${btn.id}`"
				@click="!disabled && onClickButton(btn)"
				:style="{
					'--left': btn.area.split(',')[0] / maxWidth,
					'--top': btn.area.split(',')[1] / maxHeight,
					'--width': btn.area.split(',')[2] / maxWidth,
					'--height': btn.area.split(',')[3] / maxHeight
				}"
			></A>
		</div>
	</section>
</template>
<script>
	export default {
		props: ['meta', 'btns', 'line', 'first_only'],
		data() { return { disabled: false } },
		methods: {
			onClickButton(btn) {
				if (Number(btn.first_only)) this.disabled = true;
				this.$emit('select', btn);
			}
		},
		computed: {
			myMeta() {
				return typeof this.meta === 'string' ? this.parseJSON(this.meta) : this.meta;
			},

			ratio() {
				return this.myMeta[0].height / this.myMeta[0].width;
			},

			maxWidth() {
				const { width, height } = this.myMeta[0];
				return 300 * Math.min(1, width / height);
			},

			maxHeight() {
				const { width, height } = this.myMeta[0];
				return 300 * Math.min(1, height / width);
			},
			imageMapButtons() {
				return this.btns;
			},
		}
	};
</script>
<style scoped lang="scss">
	.ImageMap {
		.image-area {
			background: var(--image) center/cover;
			max-width: 100%;
			width: 60rem;
			position: relative;

			&::before {
				content: '';
				padding-top: calc(var(--ratio) * 100%);
				display: block;
			}

			.button {
				position: absolute;
				display: block;
				top: calc(var(--top) * 100%);
				left: calc(var(--left) * 100%);
				width: calc(var(--width) * 100%);
				height: calc(var(--height) * 100%);
				background-color: var(--clrTheme);

				opacity: 0;
				filter: blur(1rem);
				mix-blend-mode: screen;

				// background-color: red;

				// &:hover {
				// 	opacity: 0.5;
				// }
			}
		}
	}
</style>
